var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangularOpBeveledLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 11.6673V25.0007H4.5L4.5 14.5569C4.5 12.655 5.25555 10.8309 6.60044 9.48601C7.54045 8.546 8.7897 7.97912 10.1161 7.8907L23.9746 6.9668L27.5 11.6673ZM25.5 12.334L23.0254 9.03452L10.2492 9.88627C9.40611 9.94247 8.61211 10.3028 8.01465 10.9002C7.04484 11.87 6.5 13.1854 6.5 14.5569L6.5 23.0007H25.5V12.334Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 7.50066C23.2239 7.50066 23 7.72451 23 8.00066V19.5007L11 19.5007C9.26884 19.5007 7.6387 20.3157 6.6 21.7007L5.1 23.7007C4.93432 23.9216 4.97909 24.235 5.2 24.4007C5.42091 24.5663 5.73431 24.5216 5.9 24.3007L7.4 22.3007C8.24984 21.1675 9.58359 20.5007 11 20.5007L23.25 20.5007L26.1 24.3007C26.2657 24.5216 26.5791 24.5663 26.8 24.4007C27.0209 24.235 27.0657 23.9216 26.9 23.7007L24 19.834V8.00066C24 7.72451 23.7761 7.50066 23.5 7.50066Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangularOpBeveledLeft);
export default __webpack_public_path__ + "static/media/rectangular-op-beveled-left.9ca8a21f.svg";
export { ForwardRef as ReactComponent };